import React from "react";
import { AppointmentOverviewContext } from "../context/appointmentOverviewContext";
import Appointment from "../interface/appointment";
import SearchControllsProps from "../interface/searchControllsProps";
import FilterCheckbox from "../../../components/inputs/filterCheckbox/filterCheckbox";

const CheckBoxSpeedcoaching = (): React.JSX.Element => {
  const {
    searchControlls,
    setSearchControlls,
    appointments,
    setPaginationSettings,
  }: {
    searchControlls: SearchControllsProps;
    setSearchControlls: React.Dispatch<
      React.SetStateAction<SearchControllsProps>
    >;
    appointments: Appointment[] | null;
    setPaginationSettings: React.Dispatch<React.SetStateAction<any>>;
  } = React.useContext(AppointmentOverviewContext);

  const getCancelledCount = (): number => {
    return appointments
      ? appointments.filter(
          (appointment: Appointment) => appointment.isSpeedcoaching
        ).length
      : 0;
  };

  const onClickHandler = (): void => {
    setPaginationSettings((prev: any) => ({
      ...prev,
      page: 1,
    }));
    setSearchControlls((prev: SearchControllsProps) => ({
      ...prev,
      status: {
        ...prev.status,
        speedcoaching: !prev.status.speedcoaching,
      },
    }));
  };

  return (
    <FilterCheckbox
      disabled={searchControlls.loading}
      badgeContent={getCancelledCount()}
      onClickHandler={onClickHandler}
      label="Speedcoaching"
      checked={searchControlls.status.speedcoaching}
    />
  );
};

export default CheckBoxSpeedcoaching;
